import * as mobx from 'mobx';
import * as IoC from 'typescript-ioc';
import { ConnectionType, IConnectionDetailsDTO, IMeetingConnectionsDTO, onChangeConnectionEntity } from '../../../../../../api/connections.dao';
import { IEventDetailsDTO } from '../../../../../../api/events.dao';
import { MeetingConnectionsAggregateRoot } from '../../../../../../modules/connections/meeting/meeting-connections.aggregate-root';
import { ISubWindowFormMethods } from '../../../manage-event.viewmodel';
import { UniqueJoiningLInksAlertsPopup } from '../../../../../../infrastructure/utils/unique-joining-lInks-alerts-popup.viewmodel';
import { EventExecutionRuntime } from '../../../../../../domain/jobs/implementations/event-execution-runtime';
import TrackingServiceProvider from '../../../../../../tracking-service/tracking-service-provider';
import { ChildConnectionsViewModel } from '../child-connections/child-connections.viewmodel';

export interface WebParticipantsModalHostProps {
    event: IEventDetailsDTO;
    accountId: number;
    meetingId: number;
    meetingConnectionFormDataVM: MeetingConnectionsAggregateRoot;
    subWindowFormMethods: ISubWindowFormMethods;
    editConnection: (
        meetingId: number,
        connection: IConnectionDetailsDTO,
        onSuccess?: (updatedDetails?: IConnectionDetailsDTO) => void
    ) => void;
    formSubmitAction: () => Promise<boolean>;
    initData: IMeetingConnectionsDTO;
}

class UniqueJoiningLinkFormVM {

    @mobx.observable
    private saving: boolean = false;
    @mobx.observable
    private loading: boolean = false;
    @mobx.observable
    private isFormDataReady: boolean = true;

    constructor(
        private readonly accountId: number,
        public readonly eventDTO: IEventDetailsDTO,
        private readonly meetingId: number,
        private readonly meetingConnectionFormDataVM: MeetingConnectionsAggregateRoot,
        private readonly subWindowFormMethods: ISubWindowFormMethods,
        public onChangeMeetingConnection: (entity: onChangeConnectionEntity, connectionId: number | null) => void,
        public readonly editConnection: (
            meetingId: number,
            connection: IConnectionDetailsDTO,
            onSuccess?: (updatedDetails?: IConnectionDetailsDTO) => void,
        ) => void,
        private readonly formSubmitAction: (data?: IMeetingConnectionsDTO) => Promise<boolean>,
        private readonly initData: IMeetingConnectionsDTO,
        public readonly updateUniqueJoiningLinkForm: (callback: () => void) => void,
        private readonly saveCompletedCallback: () => Promise<void>,
        public readonly closeMeetingConnectionPopUp: () => void,
        public readonly childConnectionsVM: ChildConnectionsViewModel,
        @IoC.Inject private readonly eventExecutionRuntime = IoC.Container.get(EventExecutionRuntime),
        @IoC.Inject private readonly trackingService: TrackingServiceProvider = IoC.Container.get(TrackingServiceProvider),
    ) {
    }

    public isSaving() { return this.saving; }

    public getIsFormDataReady() { return this.isFormDataReady; }
    public getEventTimeZone() { return this.eventDTO.timeZone; }

    public get dataVM() { return this.meetingConnectionFormDataVM; }

    public handleSubmitAction = async () => {
        const data = {
            ...this.initData,
            registrants: this.dataVM.toDTO().registrants,
        };

        return this.formSubmitAction(data);
    };

    public runMeeting = () => {
        this.subWindowFormMethods.control.openEditSubWindow(this.meetingId);
    };

    public editMeeting = () => {
        this.subWindowFormMethods.schedule.openEditSubWindow(this.meetingId);
    };

    public trackCopyButtonMixPanel = (eventName: string, type: string): void => {
        this.trackingService.get().track(eventName,{
            [eventName]: 'Yes',
            'Connection Type': type,
        });
    };

    public handleEditConnection = (connection: IConnectionDetailsDTO) => {
        this.editConnection(this.meetingId, connection, (updatedDetailsResponse: IConnectionDetailsDTO) => {
            if (updatedDetailsResponse) {
                this.meetingConnectionFormDataVM.setMeetingConnection(updatedDetailsResponse);
            } else {
                this.meetingConnectionFormDataVM.removeMeetingConnectionById(connection.meetingConnectionId);
            }
        });
    };

    public shouldDisableDeleteUJLButton = (): boolean => {
        return !this.dataVM.getMeetingConnectionsListByType(ConnectionType.UniqueJoiningLink).length
        || !this.eventExecutionRuntime.isReady();
    };

    public handleDeleteUJL = (): void => {
        const commonAlertsPopup = new UniqueJoiningLInksAlertsPopup(
            this.meetingId,
            this.closeMeetingConnectionPopUp,
            this.saveCompletedCallback,
        );
        commonAlertsPopup.handleRemoveUniqueJoiningLinksInBatch();
    };
}

export { UniqueJoiningLinkFormVM };
